import { FileMimetype } from 'constants/misc'

/**
 * Photo Studio file type constants
 */
export enum PhotoStudioFileType {
  MASK = FileMimetype.IMAGE_PNG, // Always PNG for mask files
  TEMPORARY_VISUAL = FileMimetype.IMAGE_JPEG, // Always JPEG for temporary visual files
}

/**
 * Mask upload scopes for Photo Studio AI tools
 */
export enum PhotoStudioAIMaskScope {
  DEFAULT = 'PHOTO_STUDIO_AI_MASK',
  VISUAL_STAGING = 'VISUAL_STAGING_MASK',
}
